import { render } from "./page-home.vue?vue&type=template&id=f5bf71aa"
import script from "./page-home.vue?vue&type=script&lang=js"
export * from "./page-home.vue?vue&type=script&lang=js"

import "./page-home.vue?vue&type=style&index=0&id=f5bf71aa&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__